import { useEffect, useState } from 'react';

export type TimeOfDay = 'morning' | 'afternoon' | 'evening';

function getTimeOfDay(): TimeOfDay {
  const hour = new Date().getHours();
  if (hour >= 6 && hour < 12) return 'morning';
  if (hour >= 12 && hour < 17) return 'afternoon';
  return 'evening';
}

/**
 * Sets `data-time` and optionally `data-nighttime` on <html>.
 * Updates every 60 seconds.
 */
export function useTimeOfDay(nighttime = false) {
  const [time, setTime] = useState<TimeOfDay>(getTimeOfDay);

  useEffect(() => {
    const update = () => setTime(getTimeOfDay());
    const id = setInterval(update, 60_000);
    return () => clearInterval(id);
  }, []);

  useEffect(() => {
    document.documentElement.setAttribute('data-time', time);
  }, [time]);

  useEffect(() => {
    if (nighttime) {
      document.documentElement.setAttribute('data-nighttime', 'true');
    } else {
      document.documentElement.removeAttribute('data-nighttime');
    }
  }, [nighttime]);

  return time;
}
